"use strict";

exports.__esModule = true;
exports.entries = entries;
exports.constHas = exports.memoizedValues = void 0;

var _belter = require("belter");

const memoizedValues = (0, _belter.memoize)(_belter.values);
exports.memoizedValues = memoizedValues;

const constHas = (constant, value) => {
  return memoizedValues(constant).indexOf(value) !== -1;
};

exports.constHas = constHas;

function entries(obj) {
  const result = [];

  for (const key of Object.keys(obj)) {
    result.push([key, obj[key]]);
  }

  return result;
}